"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var differenceBy_1 = tslib_1.__importDefault(require("lodash/fp/differenceBy"));
var uniqBy_1 = tslib_1.__importDefault(require("lodash/fp/uniqBy"));
var headerCheckboxClickRollupHandler = function (_a) {
    var isSelected = _a.isSelected, _b = _a.onChange, onChange = _b === void 0 ? noop_1.default : _b, value = _a.value, associatedValues = _a.associatedValues;
    if (isSelected) {
        onChange(differenceBy_1.default('value', value, associatedValues), {
            action: 'deselect-option',
        });
    }
    else {
        onChange(uniqBy_1.default('value', tslib_1.__spreadArrays(value, associatedValues)), {
            action: 'select-option',
        });
    }
};
exports.default = headerCheckboxClickRollupHandler;
